import selectOptionsMaster from '../FireORMModelSharedRecources/modelDefinitions/selectOptionsMaster'
import files from '../FireORMModelSharedRecources/modelDefinitions/files'
import userGroups from '../FireORMModelSharedRecources/modelDefinitions/userGroups'
import users from '../FireORMModelSharedRecources/modelDefinitions/users'
import dataImportSettings from '../FireORMModelSharedRecources/modelDefinitions/dataImportSettings'
import importableModels from '../FireORMModelSharedRecources/modelDefinitions/importableModels'

const models = {
  selectOptionsMaster,
  files,
  userGroups,
  users,
  dataImportSettings,
  importableModels,
}

export type TModelName = keyof typeof models
export default models
